var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotv"},[_vm._v(" "+_vm._s(_vm.displayNum || "--")+" "),_c('div',{staticClass:"ani",class:{ showIncrease: _vm.increase }},[_vm._v("+"+_vm._s(_vm.increase))])])
}
var staticRenderFns = []

export { render, staticRenderFns }